/* Listicle — sticky bar + lightweight tracking.
   Re-initialises on shopify:section:load/unload so the theme editor works. */
(function () {
  'use strict';

  function track(event, detail) {
    document.dispatchEvent(new CustomEvent(event, { detail: detail }));
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: event }, detail));
    }
  }

  /* ---------- Sticky bar ---------- */
  function initSticky(scope) {
    var bar = (scope || document).querySelector('[data-listicle-sticky]');
    if (!bar) return;
    if (bar._listicleIO) {
      bar._listicleIO.disconnect();
      bar._listicleIO = null;
    }
    if (bar.dataset.showAfterHero !== 'true') {
      bar.classList.add('is-visible');
      return;
    }
    var header = document.querySelector('.listicle-header');
    if (!header || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    bar.classList.remove('is-visible');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    });
    io.observe(header);
    bar._listicleIO = io;
  }

  /* ---------- CTA click attribution (offer / faq / sticky) ---------- */
  var ctaBound = false;
  function initCtaTracking() {
    if (ctaBound) return;
    ctaBound = true;
    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-listicle-cta]');
      if (cta) {
        track('listicle:cta_click', { placement: cta.dataset.listicleCta });
      }
    });
  }

  /* ---------- Scroll depth 25/50/75/100 ---------- */
  var depthsFired = {};
  function initScrollDepth() {
    var thresholds = [25, 50, 75, 100];
    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = Math.round(((window.scrollY || doc.scrollTop) / scrollable) * 100);
      thresholds.forEach(function (t) {
        if (pct >= t && !depthsFired[t]) {
          depthsFired[t] = true;
          track('listicle:scroll_depth', { depth: t });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Per-reason visibility ---------- */
  function initReasonViews(scope) {
    if (!('IntersectionObserver' in window)) return;
    var reasons = (scope || document).querySelectorAll('.listicle-reason:not([data-listicle-seen-bound])');
    if (!reasons.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('listicle:reason_view', { index: entry.target.dataset.listicleReasonIndex });
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    reasons.forEach(function (el) {
      el.setAttribute('data-listicle-seen-bound', '');
      io.observe(el);
    });
  }

  function initAll(scope) {
    initSticky(scope);
    initCtaTracking();
    initScrollDepth();
    initReasonViews(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme editor: sections get re-rendered while editing */
  document.addEventListener('shopify:section:load', function (event) {
    initSticky(document);
    initReasonViews(event.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    initSticky(document);
  });
})();
